module.exports = __webpack_public_path__ + "media/img/institutions/student-avatar-bg-2-0063b91721052a9b6cac3ef05c35c2ac.svg";